export default __webpack_public_path__ + "static/media/g8.21b401f1.webp";